import axiosInstance from '@/utils/api.js'

var state = {
  adminMsgs: [],
  newMsgs: [],
  adminID: []
}

var getters = {
  ADMIN_MSGS: (state) => {
    return state.adminMsgs
  },
  NEW_MSGS: (state) => {
    return state.newMsgs
  },
  ADMIN_ID: (state) => {
    return state.adminID
  }
}

var mutations = {
  SET_ADMIN_MSGS: (state, payload) => {
    state.adminMsgs = payload
  },
  SET_NEW_MSGS: (state, payload) => {
    state.newMsgs = payload
  },
  SET_ADMIN_ID: (state, payload) => {
    state.adminID = payload
  }
}

var actions = {
  GET_ADMIN_MSGS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/ts_chat/admin_msgs?admin_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ADMIN_MSGS', result.data)
    }
  },
  GET_NEW_MSGS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/ts_chat/new_customer_msgs?from=' + payload)
    if (result.status === 200) {
      context.commit('SET_NEW_MSGS', result.data)
    }
  },
  GET_ADMIN_ID: async (context, payload) => {
    let result = await axiosInstance.get('/users/who_am_i')
    if (result.status === 200) {
      context.commit('SET_ADMIN_ID', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/support.js